/**
 * Page 404 — route introuvable
 */

import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found-page">
      <div className="not-found-card">
        <h1>Page introuvable</h1>
        <p>
          Cette adresse n&apos;existe pas ou a été déplacée.
          Vérifiez l&apos;URL ou retournez à l&apos;accueil.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="btn-primary">Accueil</Link>
          <Link to="/login" className="btn-secondary">Connexion</Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
